export default __webpack_public_path__ + "static/media/voucher.fc261398.svg";